import React, {Component} from 'react';
import {FaIcon} from "../FaIcon";
import {Button} from "reactstrap";

export class PrimaryButton extends Component {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(event) {
        event.stopPropagation();
        this.props.onClick(event);
    }

    render() {
        return <Button className="-alt button-with-icon" onClick={this.handleClick}>
            <FaIcon iconName={this.props.icon} className="fa-lg fa-icon"/>
            <span className={this.props.showText===false?"text-on-hover":""}>&nbsp;&nbsp;{this.props.text}</span>
        </Button>;
    }
}
